var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.update)?_c('Masonry',{attrs:{"title":"收费文章","category_path":"members","category_id":_vm.categoryID}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }